var _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4, _ellipse, _path5, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 109,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5304 72.6037H47.1509C47.3371 72.5698 47.7907 72.6037 48.1156 73.0099L50.4513 76.9703C50.502 77.0718 50.6036 77.346 50.6036 77.6304V81.54C50.6036 81.7431 50.4513 82.1798 49.842 82.3016H30.5983C30.2091 82.3355 29.461 82.1696 29.5828 81.2354V78.9505H42.5304V72.6037ZM43.8882 74.2191V77.4179H48.4072L46.63 74.2191H43.8882Z",
    fill: "#F2453D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8411 70.5638V71.2747H25.7283C25.0378 71.2747 24.9667 71.647 25.0175 71.8331C24.8956 72.5237 25.4406 72.764 25.7283 72.7979H29.8411V74.575H27.3023C26.6524 74.6156 26.5577 74.9642 26.5915 75.1335C26.3884 75.7022 26.9808 76.0813 27.3023 76.1998H29.8411V77.8246H28.8256C28.0132 78.2714 28.284 78.9247 28.5209 79.1955H42.6871V70.5638C42.6465 69.589 41.7901 69.5822 41.367 69.7007H30.8566C30.0442 69.7413 29.8411 70.293 29.8411 70.5638Z",
    fill: "#FEC02F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.7163,
    cy: 81.527,
    r: 2.33564,
    fill: "#465A64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.767,
    cy: 81.578,
    r: 0.761621,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5451,
    cy: 81.527,
    r: 2.33564,
    fill: "#465A64"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5958,
    cy: 81.578,
    r: 0.761621,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2878 34.7109H73.5651V42.9037H45.7336C41.4926 43.5784 40.2718 46.3977 40.1914 47.723C39.7095 52.6387 43.6854 54.1086 45.7336 54.2291H69.9506C83.2519 56.3496 84.8101 65.4741 83.9266 69.7713C83.3482 79.0244 75.0109 81.9802 70.9145 82.3015H53.324V73.9882H70.9145C74.3843 73.4099 75.4928 70.936 75.6133 69.7713C76.5771 64.5665 72.2398 62.703 69.9506 62.4219H44.2878C32.4324 60.1086 31.3159 50.1327 32.2396 45.4339C33.3962 37.5302 40.7537 34.9921 44.2878 34.7109Z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4445 38.0859H47.0588C42.9624 38.1663 35.0588 40.6402 36.2154 49.8932C36.2556 52.9856 38.842 59.1945 48.8661 59.2908H72.1192C75.9345 59.9334 82.7217 63.4354 79.3481 72.3029C78.5048 73.9495 75.8783 77.4837 72.1192 78.4476H53.5649",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.981,
    cy: 41.1939,
    rx: 3.11087,
    ry: 1.16658,
    fill: "#D36A1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.344 33.4474C75.8106 35.8583 78.7141 39.5719 80.1075 41.1274L82.2463 38.0164C84.735 35.2165 85.1303 32.378 84.9683 31.5031C84.6572 27.459 81.0148 26.8368 79.2325 27.0312C74.8773 28.0423 74.8255 31.7299 75.344 33.4474Z",
    fill: "#FDB42E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.9812,
    cy: 31.4716,
    r: 1.94429,
    fill: "#D36A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTrip);
export default __webpack_public_path__ + "static/media/create-trip.32a72f18ad68fd5c9c2a033f1874b564.svg";
export { ForwardRef as ReactComponent };